var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Single",
    x: "0px",
    y: "0px",
    viewBox: "0 0 203 178",
    enableBackground: "new 0 0 203 178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#03436C",
    d: "M174.7,13.2H60.6c-6.1,0-11.1,5-11.1,11.1v117.8c0,6.7-4.9,12.4-11.1,13c-3.5,0.3-6.9-0.8-9.5-3.1 c-2.6-2.3-4-5.7-4-9.1V79.1h12.3c2.8,0,5-2.2,5-5s-2.2-5-5-5H19.8c-2.8,0-5,2.2-5,5v68.8c0,6.3,2.7,12.3,7.3,16.5 c4.1,3.7,9.3,5.7,14.8,5.8c0.1,0,0.1,0,0.2,0h127.4c11.8,0,21.4-9.6,21.4-21.4V24.3C185.8,18.2,180.8,13.2,174.7,13.2z  M175.8,143.8c0,6.3-5.1,11.4-11.4,11.4h-109c2.5-3.7,4-8.3,4-13.1V24.3c0-0.6,0.5-1.1,1.1-1.1h114.1c0.6,0,1.1,0.5,1.1,1.1V143.8z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03436C",
    d: "M150.5,85.9c-2-1.9-5.2-1.9-7.1,0.1l-13.5,14l-19.9-20.7h3c4.9,0,9.4-1.9,12.8-5.3c3.4-3.4,5.3-8,5.3-12.8 c0-10-8.1-18.1-18.2-18.1H90.6c-2.8,0-5,2.2-5,5v59.4c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5V79.3h0.5l26.9,27.9L108.7,122 c-1.9,2-1.9,5.2,0.1,7.1c1,0.9,2.2,1.4,3.5,1.4c1.3,0,2.6-0.5,3.6-1.5l13.9-14.5l13.5,14c1,1,2.3,1.5,3.6,1.5 c1.2,0,2.5-0.5,3.5-1.4c2-1.9,2-5.1,0.1-7.1l-13.8-14.3L150.6,93C152.5,91,152.4,87.8,150.5,85.9z M121.1,61.2 c0,2.2-0.8,4.2-2.4,5.8c-1.5,1.5-3.6,2.4-5.7,2.4H95.6V53h17.3C117.4,53,121.1,56.7,121.1,61.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxIcon);
export default __webpack_public_path__ + "static/media/rxIcon.19e40a83beb76241c834800771eabf9b.svg";
export { ForwardRef as ReactComponent };